import Skeleton from "@ingka/skeleton";
import SSRIcon from "@ingka/ssr-icon";
import document from "@ingka/ssr-icon/paths/document";
import { useEffect, useState } from "react";
import { pdfPageToCanvas } from "./utils";
import { IMAGE_QUALITY_RATIO } from "./constants";

type Props = {
  url: string;
};

const PdfPreview = ({ url }: Props) => {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let aborted = false;

    setDataUrl(null);
    setError(false);

    pdfPageToCanvas(url, 380)
      .then((canvas) => {
        if (!aborted)
          setDataUrl(canvas.toDataURL("image/jpeg", IMAGE_QUALITY_RATIO));
      })
      .catch(() => {
        if (!aborted) setError(true);
      });

    return () => {
      aborted = true;
    };
  }, [url]);

  if (error) {
    return (
      <div className="flex size-full items-center justify-center bg-neutral-100">
        <SSRIcon paths={document} className="size-12 text-neutral-500" />
      </div>
    );
  }

  if (!dataUrl) {
    return <Skeleton className="size-full" />;
  }

  return (
    <img src={dataUrl} alt="PDF preview" className="size-full object-contain" />
  );
};

export default PdfPreview;
